





























import Vue from 'vue'
import { PopOutMenuItem } from '@/types/menus'
import './PopOutMenu.scss'

export default Vue.extend({
  name: 'PopOutMenu',
  props: {
    menuItems: {
      type: Array as () => PopOutMenuItem[]
    },
    icon: {
      type: String,
      default: 'ellipsis-v'
    },
    iconColor: {
      type: String,
      required: false,
      default: '#CCC'
    }
  },
  data: () => ({
    menuOpen: false,
    position: 'top',
    positionTimeout: 0
  }),
  watch: {
    menuOpen (newVal: boolean = false) {
      window.clearTimeout(this.positionTimeout)
      if (newVal) {
        const menu: HTMLElement|undefined = this.$refs.menu as HTMLElement|undefined
        if (menu === undefined) return
        const rect: ClientRect = menu.getBoundingClientRect()
        const dt: number = 40

        if (rect.top + rect.height + dt > window.screen.availHeight) {
          this.position = 'bottom'
        } else {
          this.position = 'top'
        }
      } else {
        // Without a timeout you'd see a position jump when fading out
        this.positionTimeout = window.setTimeout(() => {
          this.position = 'top'
        }, 300)
      }
    }
  },
  methods: {
    togglePopOut (): void {
      this.menuOpen = !this.menuOpen
    },
    togglePopOutOff (): void {
      this.menuOpen = false
    },
    doAction (paramAction): void {
      this.$emit('menuAction', paramAction)
      this.togglePopOutOff()
    }
  }
})
